// src/utils/kioskApi.js
//
// "Détacher la borne" (backend routes/kioskClaim.ts POST
// /kiosk-claim/facilities/:id/detach): erases the facility's device key.
// Its kiosk is refused on its next call (~5 min), forgets the facility and
// shows its association code - to move it, scan that code from the new
// facility. Used by the Manager board and the ambassador kiosk card; the
// server allows admins and the facility's ambassador only.
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

export async function detachKiosk(facilityId, token) {
  const r = await fetch(`${API_BASE_URL}/kiosk-claim/facilities/${facilityId}/detach`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.error || `HTTP ${r.status}`);
  return data;
}
